import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import TextField from '@mui/material/TextField'
import QuestionDropDown from '../QuestionDropDown'
import { useDispatch } from 'react-redux'
import { type FreeResponseQuestion, SurveyItemQuestionType } from '../../../types'
import CreateQuestionCardWrapper from '../CreateQuestionCardWrapper'
import { StyledBox, StyledDescriptiveWrapper, StyledTextField } from './styles'
import { addSurveyQuestionInSection, type ISurveySection, setSelectedQuestion, updateBranchFilterPrompt, updateQuestionInSection } from '../../../../../store/slices/SurveyTemplateSlice'
import { getEditableQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import QuestionFooter from '../../QuestionFooter'
import { v4 as uuidv4 } from 'uuid'
import { getUniqueChildBranchesDetails } from '../../../helpers'

interface CreateFreeResponseQuestionCardProps {
  sectionIndex?: number
  questionIndex?: number
  questionNumber?: number
  section: ISurveySection
  isAdminAddedQuestion?: boolean
}

const CreateFreeResponseQuestionCard: React.FC<CreateFreeResponseQuestionCardProps> = ({ sectionIndex = 0, questionIndex = 0, questionNumber, section, isAdminAddedQuestion }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()

  const [freeResponseData, setFreeResponseData] = useState<FreeResponseQuestion>({
    itemId: uuidv4(),
    isRequired: false,
    itemType: SurveyItemQuestionType.FREE_RESPONSE,
    prompt: '',
    branchingFilters: null
  })

  useEffect(() => {
    if (editableQuestion != null && editableQuestion?.question?.itemType === SurveyItemQuestionType.FREE_RESPONSE) {
      setFreeResponseData(editableQuestion.question as FreeResponseQuestion)
    }
  }, [editableQuestion])

  const handleQuestionTitle = (questionTitle: string): void => {
    // Change Question Prompt in child Branch Section Branching Filters

    if (freeResponseData?.branchingFilters) {
      dispatch(updateBranchFilterPrompt({
        childBranches: getUniqueChildBranchesDetails(freeResponseData.branchingFilters),
        prompt: questionTitle
      }))
    }
    setFreeResponseData(prevState => {
      return { ...prevState, prompt: questionTitle }
    })
  }

  const handleClickAway = (): void => {
    if (editableQuestion) {
      dispatch(updateQuestionInSection({ surveySectionId: section.surveySectionId, questionIndex, updatedQuestion: freeResponseData }))
      return
    }

    dispatch(addSurveyQuestionInSection({ surveySectionId: section.surveySectionId, question: freeResponseData }))
    dispatch(setSelectedQuestion(null))
  }
  const handleRequired = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
    setFreeResponseData((prevState: any) => {
      return { ...prevState, isRequired: checked }
    })
  }

  const footerPropsData = {
    questionIndex,
    questionData: freeResponseData,
    handleChange: handleRequired,
    handleClickAway,
    section,
    isAdminAddedQuestion
  }

  const isQuestionHaveBranchFilters = !!freeResponseData?.branchingFilters?.length

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={handleClickAway}>
      <StyledBox>
        <CreateQuestionCardWrapper isAdminAddedQuestion={isAdminAddedQuestion} questionData={freeResponseData} questionNumber={questionNumber} section={section}>
          <Box>
            <StyledDescriptiveWrapper>
              <StyledTextField type='text' value={freeResponseData?.prompt} placeholder='Type your question...' autoFocus onChange={(e) => { handleQuestionTitle(e.target.value) }} />
              <QuestionDropDown section={section} sectionIndex={sectionIndex} questionIndex={questionIndex} isQuestionHaveBranchFilters={isQuestionHaveBranchFilters} />
            </StyledDescriptiveWrapper>
            <TextField disabled type='text' placeholder='Type your response...' fullWidth />
            <QuestionFooter {...footerPropsData} />
          </Box>
        </CreateQuestionCardWrapper>
      </StyledBox>
    </ClickAwayListener>
  )
}

export default CreateFreeResponseQuestionCard
